<template>
  <div class="button-bar">
    <component
      class="bottom-bar-button"
      :class="modeToRule[mode].length==2?buttonStyle2[index]:buttonStyle1[index]"
      v-for="(item,index) in modeToRule[mode]"
      :key="index"
      :is="item"
      @click.native="$emit('bottomBarHandler',item)"
    >
      <template v-slot:[item]>
        <slot :name="item"></slot>
      </template>
    </component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BuyButton, ShareButton, VIPDetailButton,DiscontinuedButton } from '@/components/goods/button';
const BUTTON_TYPE = {
  share: 'share',
  buy: 'buy',
  vip: 'vipDetail',
  discontinued: 'discontinued',
};
const BUTTON_STLYE1 = ['blue'];
const BUTTON_STLYE2 = ['white', 'blue'];

export default {
  data() {
    return {
      buttonStyle1: BUTTON_STLYE1,
      buttonStyle2: BUTTON_STLYE2,
    };
  },
  props: {
    type: {
      type: Number,
    },
    buyState: {
      type: Boolean,
      default: false,
    },
    mode: {
      default: 'video',
    },
    canBuy: {
      type: Boolean,
      default: false,
    },
    isDiscontinued: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    videoRule() {
      // 特权（0-免费 1-会员免费 2-付费 3-会员收费）
      let buttonArr = [];
      if (this.isDiscontinued) {
        buttonArr.push(BUTTON_TYPE.discontinued);
        return buttonArr
      }
      switch (this.type) {
        case 1:
          if (!this.isPlusMember) {
            if (this.canBuy && !this.buyState) {
              buttonArr.push(BUTTON_TYPE.buy);
            }
            buttonArr.push(BUTTON_TYPE.vip);
          } else {
            if (this.canBuy) {
              buttonArr.push(BUTTON_TYPE.share);
            }
          }
          break;
        case 2:
          if (this.isPlusMember) {
            buttonArr.push(BUTTON_TYPE.share);
          }
          if (!this.buyState) {
            buttonArr.push(BUTTON_TYPE.buy);
          }
          break;
        case 3:
          if (this.isPlusMember) {
            buttonArr.push(BUTTON_TYPE.share);
          } else {
            buttonArr.push(BUTTON_TYPE.buy);
            buttonArr.push(BUTTON_TYPE.vip);
          }
          break;
      }
      return buttonArr;
    },
  },
  computed: {
    ...mapGetters({
      isPlusMember: 'auth/isPlusMember',
    }),
    modeToRule() {
      return {
        video: this.videoRule(),
      };
    },
  },
  components: {
    buy: BuyButton,
    share: ShareButton,
    vipDetail: VIPDetailButton,
    discontinued: DiscontinuedButton,
  },
};
</script>

<style scoped>
.button-bar {
  width: 100vw;
  position: fixed;
  z-index: 999999;
  bottom: -1px;
  display: flex;
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
}
.button-bar >>> .bottom-bar-button {
  display: block;
  flex: 1;
  /* text-align: center; */
  font-size: 14px;
  /* line-height: 52px; */
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button-bar >>> .del {
  font-size: 12px;
  color: #ffffff;
  text-decoration: line-through;
  margin-left: 3px;
}
.button-bar >>> .white {
  background: #ffffff;
  color: #74b3fa;
  border: 1px solid rgba(231, 232, 233, 1);
  border-radius: 8px 0 0 0;
}
.button-bar >>> .blue {
  background: #74b3fa;
  color: #fff;
}
</style>
